import React from 'react';
import CommonModal from '@components/common/CommonModal';
import ButtonModal from '@components/common/Button';
import { buttonNames } from '@constants/appConstants';
import dayjs from 'dayjs';
import { dateFormate } from '@constants/index';

interface ReAuthenticateConfirmationModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  onConfirm: () => void;
  authenticationDate?: string;
  authenticatedBy?: string;
}

const ReAuthenticateConfirmationModal: React.FC<ReAuthenticateConfirmationModalProps> = ({
  showModal,
  setShowModal,
  onConfirm,
  authenticationDate,
  authenticatedBy
}) => {

  const handleConfirm = () => {
    setShowModal(false);
    onConfirm();
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const formattedDate = authenticationDate 
    ? dayjs(authenticationDate).format(`${dateFormate.dd_mm_yyyy} ${dateFormate.hh_mm_A}`)
    : 'N/A';

  return (
    <CommonModal
      show={showModal}
      handleClose={handleCancel}
      handleCustomBackButton={handleCancel}
      conditionalClass="modal_component dynamic_form_field"
      showCustomHeader={true}
      title=""
      size="md"
      footer={
        <>
          <ButtonModal
            onClick={handleConfirm}
            id="confirm-reauth"
            buttonName={buttonNames.yes}
            colorType={'primary'}
          />
          <br/>
          <ButtonModal
            onClick={handleCancel}
            id="cancel-reauth"
            buttonName={buttonNames.no}
            colorType={'secondary'}
          />
        </>
      }
    >
      <div className='hrp-warning-modal'>
        <div className='icon-class'>
          <i className="bi bi-exclamation-triangle" style={{fontSize: '48px', color: '#FFC107'}}></i>
        </div>
        <h4 className='header-text'>Re-Authentication Confirmation</h4>
        <div className='warning-text'>
          Already face-authenticated on <strong>{formattedDate}</strong>. Do you want to re-authenticate again?
        </div>
      </div>
    </CommonModal>
  );
};

export default ReAuthenticateConfirmationModal;
